/* 真空袋えらびナビ */
(function () {
  'use strict';

  var root = document.getElementById('pnx-vlp');
  if (!root || root.hasAttribute('data-vlp-boot')) return;
  root.setAttribute('data-vlp-boot', '1');

  var hasOwn = Object.prototype.hasOwnProperty;
  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { reduced = false; }

  var GA4_ID = 'G-F9RLGMSJ07';

  /* gtag と同じ積み方（arguments をそのまま dataLayer へ。gtag.js の読み込みはテーマでは行わない） */
  function ga4Queue() { (window.dataLayer = window.dataLayer || []).push(arguments); }

  function emit(name, params) {
    try {
      var o = copy(params || {});
      o.send_to = GA4_ID;
      ga4Queue('event', name, o);
    } catch (e) { /* 計測の失敗で画面を止めない */ }
  }

  function copy(p) {
    var o = {};
    for (var k in p) if (hasOwn.call(p, k)) o[k] = p[k];
    return o;
  }

  var canAnimate = !reduced && typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';

  function play(el, frames, opts) {
    if (!canAnimate || !el) return null;
    try { return el.animate(frames, opts); } catch (e) { return null; }
  }

  /* 案内役が一度跳ねる（クラスの付け直しで CSS の animation を走らせる） */
  function hop(el) {
    if (reduced || !el) return;
    el.classList.remove('is-hop');
    void el.getBoundingClientRect();
    el.classList.add('is-hop');
  }

  /* Q2 で選んだ丸が弾む（利用者が Q2 を操作したときだけ。URL の答えの復元では動かさない） */
  function popHeat() {
    var dot = root.querySelector('.pnx-vlp-scale input[name="pnx-vlp-heat"]:checked ~ .pnx-vlp-scale__dot');
    if (!dot && noneOpen) dot = root.querySelector('[data-vlp-heat-none] .pnx-vlp-scale__dot');
    play(dot, [{ transform: 'scale(1)' }, { transform: 'scale(1.34)', offset: 0.35 }, { transform: 'scale(.94)', offset: 0.6 },
      { transform: 'scale(1.16)', offset: 0.8 }, { transform: 'scale(1.12)' }], { duration: 500, easing: 'cubic-bezier(.3,.7,.4,1)' });
  }

  function scrollToEl(el, block) {
    if (!el) return;
    try { el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: block || 'start' }); } catch (e) { el.scrollIntoView(); }
  }

  /* ── 判定（URL の読み方・状態・並び・0本の相談見出し・別注の出し分け） ── */
  var O2_VALUES = ['absorber', 'flush', 'none', 'unknown'];
  var HEAT_VALUES = ['none-frozen', 'none-chilled', '85', '90', '95', '100', '105', '120', 'other', 'unknown'];
  var HEAT_NUMBERS = ['85', '90', '95', '100', '105', '120'];
  var BODY_TOKENS = ['bone', 'stand', 'zip'];
  var QUESTIONS = ['o2', 'heat', 'body'];
  var UNSURE = { o2: ['unknown'], heat: ['other', 'unknown'] };
  var UNSURE_LABEL = { o2: '脱酸素剤・ガス置換', heat: '加熱条件' };
  var IRODORI_BASE = 'xt-90';
  var LABEL = {
    'o2:absorber': '脱酸素剤対応', 'o2:flush': 'ガス置換対応',
    'heat:none-frozen': '冷凍', 'heat:85': '85℃・30分ボイル', 'heat:90': '90℃・30分ボイル',
    'heat:95': '95℃・30分ボイル', 'heat:100': '100℃・30分ボイル', 'heat:105': '105℃高温ボイル',
    'heat:120': '120℃レトルト',
    'body:bone': '骨や角に強い袋', 'body:stand': '自立袋', 'body:zip': 'チャック付き袋'
  };
  var HEADING = {
    unfiltered: '質問に答えると、候補を絞り込めます',
    partial: '答えた条件に合う候補（あと{remaining}問）',
    candidate: '入力した条件に合う候補 {count}シリーズ',
    reference: '確認できた条件での参考候補です。未確認の条件があります（{unsure}）',
    zero: '今回の条件では、当店の診断対象{total}シリーズの中に、適合を確認できる候補が見つかりませんでした。'
  };
  var HEAT_KINDS = ['none', 'boil', 'high_boil', 'retort'];
  var FORMS = ['flat', 'tube', 'stand', 'zip', 'stand_zip'];
  var FORM_BODY = { flat: [], tube: [], stand: ['stand'], zip: ['zip'], stand_zip: ['stand', 'zip'] };
  var ROLES = ['general', 'special'];
  var COLDS = ['frozen', 'chilled'];
  var SEED_KEYS = ['heat_max_c', 'heat_minutes', 'heat_kind', 'o2_absorber', 'gas_flush', 'form', 'strong', 'role', 'cold', 'caution'];
  var LIVE_KEYS = ['sales_rank', 'case_min', 'case_max', 'pack100', 'sizes'];

  function has(arr, v) { return arr.indexOf(v) >= 0; }
  function isInt(v) { return typeof v === 'number' && isFinite(v) && Math.floor(v) === v; }

  function decodePart(s) {
    var t = s.replace(/\+/g, ' ');
    try { return decodeURIComponent(t); } catch (e) { return t; }
  }

  function queryPairs(search) {
    var s = String(search || '').replace(/^\?+/, '');
    var out = [];
    if (!s) return out;
    s.split('&').forEach(function (raw) {
      if (!raw) return;
      var i = raw.indexOf('=');
      out.push({ raw: raw, key: decodePart(i < 0 ? raw : raw.slice(0, i)), value: decodePart(i < 0 ? '' : raw.slice(i + 1)) });
    });
    return out;
  }

  function parseQuery(search) {
    var q = Object.create(null);
    queryPairs(search).forEach(function (p) { (q[p.key] = q[p.key] || []).push(p.value); });
    function one(k) { return q[k] && q[k].length === 1 ? q[k][0] : null; }
    var o2 = one('o2'), heat = one('heat'), raw = one('body'), body = null;
    if (raw !== null) {
      var toks = raw.split(',');
      var uniq = toks.filter(function (t, i) { return toks.indexOf(t) === i; }).length === toks.length;
      if (toks.length === 1 && toks[0] === 'none') body = ['none'];
      else if (toks.length && uniq && toks.every(function (t) { return has(BODY_TOKENS, t); })) {
        body = BODY_TOKENS.filter(function (t) { return has(toks, t); });
      }
    }
    return { o2: has(O2_VALUES, o2) ? o2 : null, heat: has(HEAT_VALUES, heat) ? heat : null, body: body };
  }

  function constraints(ans) {
    var out = [];
    if (ans.o2 === 'absorber' || ans.o2 === 'flush') out.push(['o2', ans.o2]);
    if (ans.heat === 'none-frozen' || has(HEAT_NUMBERS, ans.heat)) out.push(['heat', ans.heat]);
    (ans.body || []).forEach(function (t) { if (has(BODY_TOKENS, t)) out.push(['body', t]); });
    return out;
  }

  function passes(f, cons) {
    for (var i = 0; i < cons.length; i++) {
      var q = cons[i][0], v = cons[i][1];
      if (q === 'o2' && !f[v === 'absorber' ? 'o2_absorber' : 'gas_flush']) return false;
      if (q === 'heat' && v === 'none-frozen' && f.cold !== 'frozen') return false;
      if (q === 'heat' && has(HEAT_NUMBERS, v) && !(f.heat_minutes === 30 && f.heat_max_c !== null && f.heat_max_c >= Number(v))) return false;
      if (q === 'body' && v === 'bone' && !f.strong) return false;
      if (q === 'body' && (v === 'stand' || v === 'zip') && !has(FORM_BODY[f.form], v)) return false;
    }
    return true;
  }

  function wantedSpecial(f, ans) {
    var body = ans.body || [];
    return FORM_BODY[f.form].some(function (t) { return has(body, t); }) ||
      (ans.heat === 'none-chilled' && f.cold === 'chilled') || (ans.heat === '120' && f.heat_kind === 'retort');
  }

  function sortKey(h, f, ans) {
    var heatUnsure = has(UNSURE.heat, ans.heat);
    return [heatUnsure && !(f.heat_max_c !== null && f.heat_max_c >= 100) ? 1 : 0,
      f.role === 'special' && !wantedSpecial(f, ans) ? 1 : 0,
      ans.o2 === 'none' && f.o2_absorber ? 1 : 0,
      f.sales_rank, h];
  }

  function cmpKeys(a, b) {
    for (var i = 0; i < a.length; i++) {
      if (a[i] < b[i]) return -1;
      if (a[i] > b[i]) return 1;
    }
    return 0;
  }

  function combinations(arr, n) {
    var out = [];
    (function rec(start, combo) {
      if (combo.length === n) { out.push(combo.slice()); return; }
      for (var i = start; i < arr.length; i++) { combo.push(arr[i]); rec(i + 1, combo); combo.pop(); }
    })(0, []);
    return out;
  }

  function findConflict(facets, handles, cons) {
    for (var n = 1; n <= cons.length; n++) {
      var combos = combinations(cons, n);
      for (var i = 0; i < combos.length; i++) {
        var combo = combos[i];
        if (!handles.some(function (h) { return passes(facets[h], combo); })) return combo;
      }
    }
    return cons.slice();
  }

  function irodoriOf(ans, remaining, unsure, hits) {
    var body = ans.body || [];
    if (ans.o2 === 'absorber' || ans.o2 === 'flush' || ans.heat === '105' || ans.heat === '120' ||
      has(body, 'stand') || has(body, 'zip')) return 'none';
    if (unsure.length) return 'consult';
    if (remaining) return 'none';
    return has(hits, IRODORI_BASE) ? 'match-xt' : 'match';
  }

  function judge(facets, ans) {
    var handles = Object.keys(facets);
    if (!handles.length) throw new Error('empty');
    var remaining = QUESTIONS.filter(function (q) { return ans[q] == null; }).length;
    var unsure = ['o2', 'heat'].filter(function (q) { return has(UNSURE[q], ans[q]); });
    var out = { state: null, remaining: remaining, unsure: unsure, candidates: [], heading: '', irodori: 'none',
      conflict: [], conflictPairs: [], bulk_heading: '', cons: [] };
    if (remaining === 3) {
      out.state = 'unfiltered';
      out.heading = HEADING.unfiltered;
      out.candidates = handles.slice().sort(function (a, b) {
        return cmpKeys([facets[a].sales_rank, a], [facets[b].sales_rank, b]);
      }).slice(0, 3);
      return out;
    }
    var cons = constraints(ans);
    out.cons = cons;
    var hits = handles.filter(function (h) { return passes(facets[h], cons); }).sort(function (a, b) {
      return cmpKeys(sortKey(a, facets[a], ans), sortKey(b, facets[b], ans));
    });
    if (!hits.length) {
      var conflict = findConflict(facets, handles, cons);
      out.state = 'zero';
      out.heading = HEADING.zero.replace('{total}', String(handles.length));
      out.conflictPairs = conflict;
      out.conflict = conflict.map(function (c) { return c[0] + ':' + c[1]; });
      out.bulk_heading = conflict.map(function (c) { return LABEL[c[0] + ':' + c[1]]; }).join('・') + 'について相談する';
      return out;
    }
    if (unsure.length) {
      out.state = 'reference';
      out.heading = HEADING.reference.replace('{unsure}', unsure.map(function (q) { return UNSURE_LABEL[q]; }).join('、'));
    } else if (remaining) {
      out.state = 'partial';
      out.heading = HEADING.partial.replace('{remaining}', String(remaining));
    } else {
      out.state = 'candidate';
      out.heading = HEADING.candidate.replace('{count}', String(hits.length));
    }
    out.candidates = hits;
    out.irodori = irodoriOf(ans, remaining, unsure, hits);
    return out;
  }

  /* 棚メタの厳密な判定（キーがそろい、型が合うか） */
  function validFacets(f) {
    if (!f || typeof f !== 'object' || Array.isArray(f)) return false;
    var keys = ['v', 'why'].concat(SEED_KEYS, LIVE_KEYS);
    for (var i = 0; i < keys.length; i++) if (!hasOwn.call(f, keys[i])) return false;
    if (f.v !== 1) return false;
    if (!(f.heat_max_c === null || isInt(f.heat_max_c))) return false;
    if (!(f.heat_minutes === null || isInt(f.heat_minutes))) return false;
    if (!has(HEAT_KINDS, f.heat_kind) || !has(FORMS, f.form) || !has(ROLES, f.role) || !has(COLDS, f.cold)) return false;
    if (typeof f.o2_absorber !== 'boolean' || typeof f.gas_flush !== 'boolean' || typeof f.strong !== 'boolean') return false;
    if (!Array.isArray(f.caution) || !f.caution.every(function (c) { return typeof c === 'string'; })) return false;
    for (var j = 0; j < LIVE_KEYS.length; j++) if (!isInt(f[LIVE_KEYS[j]])) return false;
    return typeof f.why === 'string' && f.why.trim() !== '';
  }

  /* ── 画面の文 ── */
  var Q_TEXT = {
    o2: { absorber: '脱酸素剤を使う', flush: 'ガス置換をする', none: 'どちらも使わない', unknown: 'わからない' },
    heat: { 'none-frozen': '加熱しない・冷凍する', 'none-chilled': '加熱しない・冷蔵だけ', '85': '85', '90': '90',
      '95': '95', '100': '100', '105': '105 高温ボイル', '120': '120 レトルト',
      other: '30分を超える・その他の加熱', unknown: '温度や時間がわからない' },
    body: { bone: '骨や角など、とがった部分がある', stand: '自立する形', zip: 'チャック付き', none: '特になし' }
  };

  function reasonText(c) {
    var q = c[0], v = c[1];
    if (q === 'o2') return v === 'absorber' ? '脱酸素剤に対応' : 'ガス置換に対応';
    if (q === 'heat') {
      if (v === 'none-frozen') return '冷凍に対応';
      if (v === '105') return '105℃・30分の高温ボイルに対応';
      if (v === '120') return '120℃・30分のレトルト殺菌に対応';
      return v + '℃・30分のボイルに対応';
    }
    return { bone: '骨や角に強い', stand: '自立する形', zip: 'チャック付き' }[v];
  }

  function zeroReason(pairs) {
    var ls = pairs.map(function (c) { return '「' + LABEL[c[0] + ':' + c[1]] + '」'; });
    if (ls.length === 1) return ls[0] + 'を満たすシリーズがありません。';
    if (ls.length === 2) return ls[0] + 'と' + ls[1] + 'の両方を満たすシリーズがありません。';
    return ls.join('') + 'をすべて満たすシリーズがありません。';
  }

  /* ── 診断 ── */
  var diag = null;

  function initDiag() {
    var q = function (sel) { return root.querySelector(sel); };
    var results = q('[data-vlp-results]');
    var heading = q('[data-vlp-heading]');
    var bulkHeading = q('[data-vlp-bulk-heading]');
    var more = q('[data-vlp-more]');
    var moreList = q('[data-vlp-more-list]');
    var missing = q('[data-vlp-missing]');
    if (!results || !heading || !bulkHeading || !more || !moreList || !missing) throw new Error('markup');

    var bulkDefault = bulkHeading.textContent;
    var headingDefault = heading.textContent;
    var resultsOrig = Array.prototype.slice.call(results.childNodes);
    var missingOrig = Array.prototype.slice.call(missing.childNodes);
    var totals = Array.prototype.slice.call(root.querySelectorAll('[data-vlp-total]'));
    var totalsOrig = totals.map(function (el) { return el.textContent; });
    var derived = Array.prototype.slice.call(root.querySelectorAll('[data-vlp-o2-count], [data-vlp-pack100], [data-vlp-o2-wrap], [data-vlp-pack100-wrap]'))
      .map(function (el) { return { el: el, text: el.children.length ? null : el.textContent, hidden: el.hidden }; });
    var tops = Array.prototype.slice.call(root.querySelectorAll('[data-vlp-click="usual"]'))
      .map(function (el) { return { el: el, on: el.classList.contains('is-top') }; });

    function restore() {
      resultsOrig.forEach(function (n) { results.appendChild(n); });
      missingOrig.forEach(function (n) { missing.appendChild(n); });
      Array.prototype.forEach.call(root.querySelectorAll('[data-vlp-card]'), function (c) {
        c.hidden = false;
        c.setAttribute('data-vlp-match', '1');
        var r = c.querySelector('[data-vlp-reason]');
        if (r) { r.hidden = true; r.textContent = ''; }
      });
      more.hidden = true;
      ['[data-vlp-first]', '[data-vlp-reference]', '[data-vlp-zero]', '[data-vlp-irodori-box]'].forEach(function (sel) {
        var el = root.querySelector(sel);
        if (el) el.hidden = true;
      });
      derived.forEach(function (x) { if (x.text !== null) x.el.textContent = x.text; x.el.hidden = x.hidden; });
      tops.forEach(function (x) { x.el.classList.toggle('is-top', x.on); });
      totals.forEach(function (el, i) { el.textContent = totalsOrig[i]; });
      heading.textContent = headingDefault;
      bulkHeading.textContent = bulkDefault;
    }

    var facets = {};
    var cards = {};
    var names = {};
    var order = [];
    Array.prototype.slice.call(results.querySelectorAll('[data-vlp-card]')).forEach(function (card) {
      var h = card.getAttribute('data-handle');
      var f = null;
      try { f = JSON.parse(card.getAttribute('data-vlp-facets') || 'null'); } catch (e) { f = null; }
      if (!h || hasOwn.call(facets, h) || !validFacets(f)) { missing.appendChild(card); return; }
      facets[h] = f;
      cards[h] = card;
      var nm = card.querySelector('[data-vlp-name]');
      names[h] = nm ? nm.textContent.replace(/\s+/g, ' ').trim() : h;
      order.push(h);
    });
    if (!order.length) {
      restore();
      throw new Error('empty');
    }
    totals.forEach(function (el) { el.textContent = String(order.length); });
    var o2n = order.filter(function (h) { return facets[h].o2_absorber; }).length;
    var tl = facets['tl-type'] ? facets['tl-type'].pack100 : 0;
    Array.prototype.forEach.call(root.querySelectorAll('[data-vlp-o2-count]'), function (el) { el.textContent = String(o2n); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-vlp-o2-wrap]'), function (el) { el.hidden = o2n === 0; });
    Array.prototype.forEach.call(root.querySelectorAll('[data-vlp-pack100]'), function (el) { el.textContent = String(tl); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-vlp-pack100-wrap]'), function (el) { el.hidden = !(tl > 0); });
    Array.prototype.forEach.call(root.querySelectorAll('.pnx-vlp-usual__list'), function (ul) {
      var best = null;
      Array.prototype.forEach.call(ul.querySelectorAll('[data-vlp-click="usual"]'), function (a) {
        var h = a.getAttribute('data-handle');
        if (!hasOwn.call(facets, h)) return;
        if (!best || cmpKeys([facets[h].sales_rank, h], [facets[best.h].sales_rank, best.h]) < 0) best = { h: h, el: a };
      });
      Array.prototype.forEach.call(ul.querySelectorAll('[data-vlp-click="usual"]'), function (a) {
        a.classList.toggle('is-top', !!best && a === best.el);
      });
    });

    return { results: results, heading: heading, bulkHeading: bulkHeading, bulkDefault: bulkDefault, more: more,
      moreList: moreList, facets: facets, cards: cards, names: names, order: order, restore: restore };
  }

  function snapshot() {
    var m = {};
    diag.order.forEach(function (h) {
      var c = diag.cards[h];
      if (c.getClientRects().length) m[h] = c.getBoundingClientRect();
    });
    return m;
  }

  function ghost(card, old) {
    var host = diag.results.getBoundingClientRect();
    var g = card.cloneNode(true);
    ['data-vlp-card', 'data-handle', 'data-vlp-match', 'data-vlp-sizes', 'data-vlp-facets', 'id'].forEach(function (a) { g.removeAttribute(a); });
    Array.prototype.forEach.call(g.querySelectorAll('[data-vlp-click], [data-vlp-name], [data-vlp-reason], [id]'), function (el) {
      ['data-vlp-click', 'data-vlp-name', 'data-vlp-reason', 'id', 'href'].forEach(function (a) { el.removeAttribute(a); });
    });
    g.hidden = false;
    g.setAttribute('aria-hidden', 'true');
    g.className += ' pnx-vlp-ghost';
    g.style.left = (old.left - host.left) + 'px';
    g.style.top = (old.top - host.top) + 'px';
    g.style.width = old.width + 'px';
    diag.results.appendChild(g);
    var a = play(g, [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(.96)' }], { duration: 260, easing: 'ease-out', fill: 'forwards' });
    if (a) a.onfinish = function () { if (g.parentNode) g.parentNode.removeChild(g); };
    else if (g.parentNode) g.parentNode.removeChild(g);
  }

  function flip(before) {
    var enter = 0;
    diag.order.forEach(function (h) {
      var c = diag.cards[h];
      var vis = c.getClientRects().length > 0;
      var old = before[h];
      if (vis && old) {
        var now = c.getBoundingClientRect();
        var dx = old.left - now.left, dy = old.top - now.top;
        if (Math.abs(dx) > 1 || Math.abs(dy) > 1) {
          play(c, [{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' });
        }
      } else if (vis) {
        play(c, [{ opacity: 0, transform: 'translateY(14px) scale(.97)' }, { opacity: 1, transform: 'none' }],
          { duration: 380, delay: 60 + 50 * Math.min(enter++, 4), easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'backwards' });
      } else if (old) {
        ghost(c, old);
      }
    });
  }

  function render(res, animate) {
    var d = diag;
    var before = animate && canAnimate ? snapshot() : null;
    root.setAttribute('data-vlp-state', res.state);
    root.setAttribute('data-vlp-remaining', String(res.remaining));
    root.setAttribute('data-vlp-unsure', res.unsure.join(','));
    root.setAttribute('data-vlp-irodori', res.irodori);
    root.setAttribute('data-vlp-conflict', res.conflict.join(','));
    d.heading.textContent = res.heading;
    d.bulkHeading.textContent = res.state === 'zero' ? res.bulk_heading : d.bulkDefault;

    var matched = res.candidates;
    var isMatch = {};
    matched.forEach(function (h) { isMatch[h] = true; });
    var reason = res.cons.length ? res.cons.map(reasonText).join('／') : '';
    var frag = document.createDocumentFragment();
    matched.slice(0, 3).forEach(function (h) { frag.appendChild(d.cards[h]); });
    frag.appendChild(d.more);
    d.order.forEach(function (h) { if (!isMatch[h]) frag.appendChild(d.cards[h]); });
    d.results.appendChild(frag);
    matched.slice(3).forEach(function (h) { d.moreList.appendChild(d.cards[h]); });
    d.order.forEach(function (h) {
      var card = d.cards[h];
      var m = !!isMatch[h];
      card.setAttribute('data-vlp-match', m ? '1' : '0');
      card.hidden = !m;
      var r = card.querySelector('[data-vlp-reason]');
      if (r) { r.textContent = reason; r.hidden = !(m && reason); }
    });
    d.more.hidden = matched.length <= 3;
    var mc = d.more.querySelector('[data-vlp-more-count]');
    if (mc) mc.textContent = String(Math.max(matched.length - 3, 0));

    setHidden('[data-vlp-first]', !(matched.length > 3 && res.state !== 'unfiltered'));
    setHidden('[data-vlp-reference]', res.state !== 'reference');
    setHidden('[data-vlp-zero]', res.state !== 'zero');
    var zr = root.querySelector('[data-vlp-zero-reason]');
    if (zr) zr.textContent = res.state === 'zero' ? zeroReason(res.conflictPairs) : '';

    var box = root.querySelector('[data-vlp-irodori-box]');
    if (box) {
      box.hidden = res.irodori === 'none';
      Array.prototype.forEach.call(box.querySelectorAll('[data-vlp-irodori-text]'), function (el) {
        el.hidden = el.getAttribute('data-vlp-irodori-text') !== res.irodori;
      });
      Array.prototype.forEach.call(box.querySelectorAll('[data-vlp-irodori-link]'), function (el) {
        el.hidden = (el.getAttribute('data-vlp-irodori-link') === 'consult') !== (res.irodori === 'consult');
      });
    }
    var count = res.state === 'zero' ? 0 : matched.length;
    var bc = root.querySelector('[data-vlp-bar-count]');
    if (bc && bc.textContent !== String(count)) {
      bc.textContent = String(count);
      if (animate) play(bc, [{ transform: 'translateY(.7em) rotateX(80deg)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.2,.8,.2,1)' });
    }
    fillAuto(res);
    if (before) flip(before);
  }

  function setHidden(sel, hidden) {
    var el = root.querySelector(sel);
    if (el) el.hidden = hidden;
  }

  /* ── 答えと入力欄 ── */
  var ans = { o2: null, heat: null, body: null };
  var noneOpen = false;
  var lastRes = null;
  var started = false;

  function inputs(q) { return Array.prototype.slice.call(root.querySelectorAll('input[name="pnx-vlp-' + q + '"]')); }

  function writeInputs() {
    inputs('o2').forEach(function (el) { el.checked = el.value === ans.o2; });
    inputs('heat').forEach(function (el) { el.checked = el.value === ans.heat; });
    inputs('body').forEach(function (el) { el.checked = !!ans.body && has(ans.body, el.value); });
    syncUi();
  }

  var STOPS = ['none', '85', '90', '95', '100', '105', '120'];

  function syncScale(anim) {
    var v = ans.heat === 'none-frozen' || ans.heat === 'none-chilled' || (ans.heat == null && noneOpen) ? 'none' : ans.heat;
    var i = STOPS.indexOf(v);
    var pos = i < 0 ? '96%' : ((i + 0.5) / STOPS.length * 100).toFixed(3) + '%';
    Array.prototype.forEach.call(root.querySelectorAll('.pnx-vlp-scale'), function (el) {
      if (!el.classList.contains('has-fill')) {
        if (i < 0) return;
        el.style.setProperty('--pnx-vlp-fill', anim && canAnimate ? '4%' : pos);
        el.classList.add('has-fill');
        void el.getBoundingClientRect();
      }
      el.style.setProperty('--pnx-vlp-fill', pos);
    });
  }

  function syncUi(anim) {
    if (ans.heat === 'none-frozen' || ans.heat === 'none-chilled') noneOpen = true;
    var noneBox = root.querySelector('#pnx-vlp-heat-none');
    if (noneBox) noneBox.hidden = !noneOpen;
    var noneBtn = root.querySelector('[data-vlp-heat-none]');
    if (noneBtn) {
      noneBtn.setAttribute('aria-expanded', noneOpen ? 'true' : 'false');
      noneBtn.classList.toggle('is-on', noneOpen);
    }
    QUESTIONS.forEach(function (qq) {
      var b = root.querySelector('[data-vlp-clear="' + qq + '"]');
      if (!b) return;
      var off = ans[qq] == null && !(qq === 'heat' && noneOpen);
      b.classList.toggle('is-off', off);
      b.setAttribute('aria-hidden', off ? 'true' : 'false');
      if (off) b.setAttribute('tabindex', '-1'); else b.removeAttribute('tabindex');
    });
    syncScale(anim);
  }

  function answerCode(q) {
    if (q === 'body') return ans.body ? ans.body.join(',') : '';
    return ans[q] || '';
  }

  function update(q, byUser) {
    var prevRemaining = lastRes ? lastRes.remaining : 3;
    var res = judge(diag.facets, ans);
    lastRes = res;
    render(res, byUser);
    syncUi(byUser);
    if (!byUser) return;
    hop(root.querySelector('#pnx-vlp-q-' + q + ' .pnx-vlp-mascot'));
    if (q === 'heat') popHeat();
    hop(root.querySelector('.pnx-vlp-result__head .pnx-vlp-mascot'));
    writeUrl();
    if (!started && ans[q] != null) {
      started = true;
      emit('vlp_start', { vlp_question: q });
    }
    emit('vlp_answer', { vlp_question: q, vlp_answer: answerCode(q) });
    if (res.remaining === 0 && prevRemaining > 0) {
      emit('vlp_complete', { vlp_state: res.state, vlp_count: res.state === 'zero' ? 0 : res.candidates.length });
    }
    armResultView();
    updateBar();
  }

  function readGroup(q) {
    if (q === 'body') {
      var on = inputs('body').filter(function (el) { return el.checked; }).map(function (el) { return el.value; });
      if (has(on, 'none')) return ['none'];
      var b = BODY_TOKENS.filter(function (t) { return has(on, t); });
      return b.length ? b : null;
    }
    var hit = inputs(q).filter(function (el) { return el.checked; })[0];
    return hit ? hit.value : null;
  }

  function onInputChange(e) {
    var el = e.target;
    if (!el || !el.name || el.name.indexOf('pnx-vlp-') !== 0) return;
    var q = el.name.slice('pnx-vlp-'.length);
    if (!has(QUESTIONS, q)) return;
    if (q === 'body' && el.checked) {
      inputs('body').forEach(function (o) {
        if (el.value === 'none' ? o.value !== 'none' : o.value === 'none') o.checked = false;
      });
    }
    if (q === 'heat') noneOpen = el.value === 'none-frozen' || el.value === 'none-chilled';
    var next = readGroup(q);
    if (String(next) === String(ans[q])) { syncUi(); return; }
    ans[q] = next;
    update(q, true);
  }

  function clearAnswer(q) {
    var had = ans[q] != null;
    ans[q] = null;
    if (q === 'heat') noneOpen = false;
    writeInputs();
    if (had) update(q, true);
  }

  function openNone(focusFirst) {
    noneOpen = true;
    if (ans.heat === 'none-frozen' || ans.heat === 'none-chilled') { syncUi(); return; }
    if (ans.heat != null) {
      ans.heat = null;
      writeInputs();
      update('heat', true);
    } else {
      syncUi();
      if (focusFirst) popHeat();
    }
    if (focusFirst) {
      var first = root.querySelector('#pnx-vlp-heat-none input');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }
  }

  function toggleNone() {
    if (noneOpen && ans.heat !== 'none-frozen' && ans.heat !== 'none-chilled') {
      noneOpen = false;
      syncUi();
      return;
    }
    openNone(true);
  }

  /* ── URL（replaceState だけ・答え以外のパラメータは元の順で後ろに残す） ── */
  var dropKeys = {};

  function writeUrl() {
    try {
      var parts = [];
      if (ans.o2) parts.push('o2=' + ans.o2);
      if (ans.heat) parts.push('heat=' + ans.heat);
      if (ans.body) parts.push('body=' + ans.body.join(','));
      queryPairs(window.location.search).forEach(function (p) {
        if (p.key === 'o2' || p.key === 'heat' || p.key === 'body' || hasOwn.call(dropKeys, p.key)) return;
        parts.push(p.raw);
      });
      var url = window.location.pathname + (parts.length ? '?' + parts.join('&') : '') + window.location.hash;
      window.history.replaceState(window.history.state, '', url);
    } catch (e) { /* URL の書き戻しに失敗しても画面は動かす */ }
  }

  function dropParam(key) {
    dropKeys[key] = true;
    try {
      var pairs = queryPairs(window.location.search);
      if (!pairs.some(function (p) { return p.key === key; })) return;
      var rest = pairs.filter(function (p) { return !hasOwn.call(dropKeys, p.key); }).map(function (p) { return p.raw; });
      var url = window.location.pathname + (rest.length ? '?' + rest.join('&') : '') + window.location.hash;
      window.history.replaceState(window.history.state, '', url);
    } catch (e) { /* 同上 */ }
  }

  /* ── 結果が画面に入った・固定バー ── */
  var resultIn = false;
  var formIn = false;
  var resultArmed = true;

  function armResultView() {
    resultArmed = true;
    if (resultIn) fireResultView();
  }

  function fireResultView() {
    if (!resultArmed || !lastRes) return;
    resultArmed = false;
    emit('vlp_result_view', { vlp_state: lastRes.state, vlp_count: lastRes.state === 'zero' ? 0 : lastRes.candidates.length });
  }

  function updateBar() {
    var bar = root.querySelector('[data-vlp-bar]');
    if (!bar) return;
    bar.hidden = !started || !lastRes || lastRes.state === 'unfiltered' || resultIn || formIn;
    if (!bar.hidden) bar.style.setProperty('--pnx-vlp-bar-offset', bottomOffset() + 'px');
  }

  /* テーマのスマホ下部バー（検索・カート等）の上に出して、押せなくしない（読むだけ） */
  function bottomOffset() {
    var off = 0;
    try {
      var el = document.querySelector('mobile-sticky-bar');
      if (el) {
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.top < window.innerHeight) off = Math.max(0, Math.round(window.innerHeight - r.top));
      }
    } catch (e) { off = 0; }
    return off;
  }

  function reveal() {
    var els = Array.prototype.slice.call(root.querySelectorAll('.pnx-vlp-reveal'));
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    root.classList.add('pnx-vlp--reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function observe() {
    if (!('IntersectionObserver' in window)) return;
    var result = root.querySelector('#pnx-vlp-result');
    var contact = root.querySelector('#pnx-vlp-contact');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.target === result) {
          resultIn = en.isIntersecting;
          if (resultIn) fireResultView();
        } else if (en.target === contact) {
          formIn = en.isIntersecting;
        }
      });
      updateBar();
    }, { threshold: 0 });
    if (result) io.observe(result);
    if (contact) io.observe(contact);
  }

  /* ── 相談フォーム（submit は止めない・入力値は読まない） ── */
  var form = document.getElementById('pnx-vlp-contact-form');
  var MARK = 'pnx-vlp-form';
  var autoLocked = { answers: false, state: false, candidates: false };

  function kindCode() {
    var sel = form && form.querySelector('[data-vlp-kind]');
    if (!sel || sel.selectedIndex < 0) return '';
    var k = sel.options[sel.selectedIndex].getAttribute('data-vlp-k') || '';
    return has(['standard', 'bulk', 'other'], k) ? k : '';
  }

  function fillAuto(res) {
    if (!form) return;
    var vals = { answers: '', state: '', candidates: '' };
    if (res.state !== 'unfiltered') {
      vals.answers = '脱酸素剤・ガス置換：' + (ans.o2 ? Q_TEXT.o2[ans.o2] : '未回答') +
        '／加熱：' + (ans.heat ? Q_TEXT.heat[ans.heat] : '未回答') +
        '／中身・袋の形：' + (ans.body ? ans.body.map(function (t) { return Q_TEXT.body[t]; }).join('・') : '未回答');
      if (res.state === 'partial') vals.state = '回答途中（あと' + res.remaining + '問）';
      else if (res.state === 'candidate') vals.state = '候補・条件確認済み';
      else if (res.state === 'reference') vals.state = '参考候補・' + res.unsure.map(function (u) { return UNSURE_LABEL[u]; }).join('、') + '未確認';
      else if (res.state === 'zero') vals.state = '0本（' + res.conflictPairs.map(function (c) { return LABEL[c[0] + ':' + c[1]]; }).join('・') + '）';
      vals.candidates = res.state === 'zero' ? 'なし' : res.candidates.map(function (h) { return diag.names[h]; }).join('、');
    }
    Object.keys(vals).forEach(function (k) {
      if (autoLocked[k]) return;
      var el = form.querySelector('[data-vlp-auto="' + k + '"]');
      if (el) el.value = vals[k];
    });
  }

  function initForm() {
    if (!form) return;
    var btn = form.querySelector('[data-vlp-submit]');
    var btnLabel = btn ? btn.textContent : '';
    var sending = false;
    var timer = null;
    var required = Array.prototype.slice.call(form.querySelectorAll('[data-vlp-required]'));
    var notice = form.querySelector('[data-vlp-form-invalid]');
    var tried = false;
    var coarse = false;
    try { coarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches); } catch (e) { /* 判定できなければ PC と同じ扱い */ }

    /* ブラウザは最初の空欄へ自動でスクロールする。その後で知らせが画面の外なら、知らせを画面の上へ（空欄はすぐ下に見える）。
       スマホでは先に入力欄の focus を外す（キーボードが空欄を隠し、ブラウザの吹き出しが画面のずれで別の欄を指すため） */
    function revealNotice() {
      if (!notice) return;
      setTimeout(function () {
        if (notice.hidden) return;
        var a = document.activeElement;
        if (coarse && a && a !== document.body && form.contains(a) && a.blur) a.blur();
        var r = notice.getBoundingClientRect();
        if (r.top >= 0 && r.bottom <= window.innerHeight) return;
        try { notice.scrollIntoView({ block: 'start', behavior: 'instant' }); } catch (e) { notice.scrollIntoView(true); }
      }, 150);
    }

    /* 入力チェックが通らないときの知らせ（値は読まない。ブラウザの validity だけで決める） */
    function showInvalid() {
      if (!notice) return;
      var missing = [];
      var badEmail = false;
      required.forEach(function (el) {
        var v = el.validity;
        if (v.valid) return;
        if (v.typeMismatch) badEmail = true;
        else missing.push(el.getAttribute('data-vlp-label') || '');
      });
      var lines = [];
      if (missing.length) lines.push('入力が必要な項目があります：' + missing.join('・'));
      if (badEmail) lines.push('メールアドレスの形をご確認ください');
      var text = lines.join('\n');
      if (notice.textContent !== text) notice.textContent = text;
      if (notice.hidden !== (lines.length === 0)) notice.hidden = lines.length === 0;
    }

    function setSending(on) {
      sending = on;
      if (!btn) return;
      if (timer) { clearTimeout(timer); timer = null; }
      if (on) {
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = '送信中…';
        timer = setTimeout(function () { setSending(false); }, 8000);
      } else {
        btn.removeAttribute('aria-disabled');
        btn.textContent = btnLabel;
      }
    }

    if (btn) {
      btn.addEventListener('click', function (e) {
        if (sending) { e.preventDefault(); return; }
        required.forEach(function (el) {
          el.setCustomValidity(el.value.length && !el.value.trim() ? '入力してください。' : '');
        });
        if (!form.checkValidity()) {
          tried = true;
          form.classList.add('is-tried');
          showInvalid();
          revealNotice();
          return;
        }
        if (notice) notice.hidden = true;
        setSending(true);
      });
    }
    required.forEach(function (el) {
      el.addEventListener('input', function () {
        el.setCustomValidity('');
        if (tried) showInvalid();
      });
    });
    form.addEventListener('keydown', function (e) {
      var enter = e.key === 'Enter' || e.code === 'Enter' || e.code === 'NumpadEnter';
      if (!enter) return;
      var t = e.target;
      if (t && t.tagName === 'INPUT' && (e.isComposing || e.keyCode === 229)) e.preventDefault();
    });
    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      try { window.sessionStorage.setItem(MARK, JSON.stringify({ t: Date.now(), k: kindCode() })); } catch (x) { /* 印を書けなくても送信は止めない */ }
    }, { capture: true, passive: true });
    window.addEventListener('pageshow', function (e) { if (e.persisted) setSending(false); });

    var startedForm = false;
    form.addEventListener('focusin', function () {
      if (startedForm) return;
      startedForm = true;
      emit('vlp_form_start', { vlp_state: lastRes ? lastRes.state : '' });
    });

    Object.keys(autoLocked).forEach(function (k) {
      var el = form.querySelector('[data-vlp-auto="' + k + '"]');
      if (el) el.addEventListener('input', function () { autoLocked[k] = true; });
    });
    var clr = form.querySelector('[data-vlp-auto-clear]');
    if (clr) {
      clr.addEventListener('click', function () {
        Object.keys(autoLocked).forEach(function (k) {
          autoLocked[k] = true;
          var el = form.querySelector('[data-vlp-auto="' + k + '"]');
          if (el) el.value = '';
        });
      });
    }
  }

  function readMark() {
    try {
      var raw = window.sessionStorage.getItem(MARK);
      if (!raw) return null;
      var m = JSON.parse(raw);
      return m && typeof m.t === 'number' ? m : null;
    } catch (e) { return null; }
  }

  function clearMark() {
    try { window.sessionStorage.removeItem(MARK); } catch (e) { /* 何もしない */ }
  }

  function afterPost() {
    if (!form) return;
    var ok = form.querySelector('[data-vlp-form-success]');
    if (ok) {
      scrollToEl(ok, 'center');
      var m = readMark();
      var age = m ? Date.now() - m.t : -1;
      if (m && age >= 0 && age <= 600000) {
        var k = has(['standard', 'bulk', 'other'], m.k) ? m.k : '';
        emit('vlp_form_success', { vlp_kind: k });
      }
      clearMark();
      dropParam('contact_posted');
    } else if (form.querySelector('[data-vlp-form-error]')) {
      clearMark();
    }
  }

  /* ── クリック ── */
  function position(card) {
    if (!card || !lastRes) return 0;
    var i = lastRes.candidates.indexOf(card.getAttribute('data-handle'));
    return i < 0 ? 0 : i + 1;
  }

  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var go = t.closest('[data-vlp-go]');
    if (go) {
      var where = go.getAttribute('data-vlp-go');
      scrollToEl(root.querySelector(where === 'diag' ? '#pnx-vlp-diag' : '#pnx-vlp-result'));
      return;
    }
    if (t.closest('[data-vlp-heat-none]')) { toggleNone(); return; }
    var clr = t.closest('[data-vlp-clear]');
    if (clr) { clearAnswer(clr.getAttribute('data-vlp-clear')); return; }
    var a = t.closest('[data-vlp-click]');
    if (!a) return;
    var target = a.getAttribute('data-vlp-click');
    var card = a.closest('[data-vlp-card]');
    var params = { vlp_target: target };
    if (target === 'series' || target === 'sample' || target === 'usual') {
      params.vlp_handle = card ? card.getAttribute('data-handle') : (a.getAttribute('data-handle') || '');
    }
    params.vlp_position = (target === 'series' || target === 'sample') ? position(card) : 0;
    params.vlp_state = lastRes ? lastRes.state : '';
    emit('vlp_click', params);
    if (a.hasAttribute('data-vlp-bulk')) {
      e.preventDefault();
      var sel = form && form.querySelector('[data-vlp-kind]');
      if (sel) {
        Array.prototype.forEach.call(sel.options, function (o, i) { if (o.getAttribute('data-vlp-k') === 'bulk') sel.selectedIndex = i; });
      }
      scrollToEl(root.querySelector('#pnx-vlp-contact'));
    }
  }

  /* ── 起動 ── */
  try { initForm(); } catch (e) { /* フォームの補助が動かなくても標準の送信は残る */ }

  try {
    root.classList.add('pnx-vlp--settling');
    diag = initDiag();
    var url = parseQuery(window.location.search);
    ans = { o2: url.o2, heat: url.heat, body: url.body };
    noneOpen = false;
    writeInputs();
    var res = judge(diag.facets, ans);
    lastRes = res;
    render(res);
    syncUi();
    root.classList.add('pnx-vlp--js');
    root.setAttribute('data-vlp-ready', '1');
    var settle = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
    settle(function () { settle(function () { root.classList.remove('pnx-vlp--settling'); }); });
  } catch (e) {
    root.classList.remove('pnx-vlp--settling');
    try { if (diag) diag.restore(); } catch (x) { /* 元に戻せない場合も JS 停止と同じ見た目へ */ }
    diag = null;
    ['data-vlp-state', 'data-vlp-remaining', 'data-vlp-unsure', 'data-vlp-irodori', 'data-vlp-conflict'].forEach(function (k) {
      root.setAttribute(k, '');
    });
    root.classList.remove('pnx-vlp--js');
    root.removeAttribute('data-vlp-ready');
  }

  if (diag) {
    try {
      var from = '';
      var fromRaw = null;
      queryPairs(window.location.search).forEach(function (p) { if (p.key === 'from' && fromRaw === null) fromRaw = p.value; });
      if (fromRaw !== null) from = /^[a-z0-9-]{1,32}$/.test(fromRaw) ? fromRaw : 'other';
      emit('vlp_view', { vlp_from: from, vlp_prefilled: 3 - lastRes.remaining });
      dropParam('from');
      root.addEventListener('change', onInputChange);
      root.addEventListener('click', onClick);
      observe();
      reveal();
      window.addEventListener('resize', updateBar, { passive: true });
      updateBar();
    } catch (e) { /* 起動後の補助の失敗で画面を止めない */ }
  }

  try { afterPost(); } catch (e) { /* 同上 */ }
})();
